import { render, staticRenderFns } from "./upsell-products.vue?vue&type=template&id=5604a90a&scoped=true&"
import script from "./upsell-products.vue?vue&type=script&lang=js&"
export * from "./upsell-products.vue?vue&type=script&lang=js&"
import style0 from "./upsell-products.vue?vue&type=style&index=0&id=5604a90a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604a90a",
  null
  
)

export default component.exports